module.exports = __webpack_public_path__ + "plus.png";